import React from 'react'
import PropTypes from 'prop-types'

const PageTemplate = ({
  title,
  description,
  className,
  center,
  children,
  noContainer
}) => (
  <div
    className={
      'page-container ' + (className || '') + (center ? 'content-center' : '')
    }
  >
    <div className='page-head'>
      <div className='container'>
        <div className='row'>
          <div className='col-xs-12'>
            <div className='page-title'>
              <h1>
                <span>{title}</span>
                <small className='hidden-xs'>{description}</small>
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className='page-content fade-in-up'>
      <div className='container'>
        {noContainer ? (
          <div>{children}</div>
        ) : (
          <div className='portlet light'>
            <div className='portlet-body'>{children}</div>
          </div>
        )}
      </div>
    </div>
  </div>
)

PageTemplate.displayName = 'PageTemplate'

PageTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  className: PropTypes.string,
  center: PropTypes.bool,
  children: PropTypes.any,
  noContainer: PropTypes.bool
}

export default PageTemplate



// WEBPACK FOOTER //
// ./src/components/page-template/index.js